<template>
    <div>
        <md-card>
            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                        <md-table v-if="tableData.length > 0 " v-model="tableData" 
                        class="md-container-custom paginated-table" table-header-color="green" md-fixed-header>
                            <md-table-row slot="md-table-row" slot-scope="{ item }">            
                                <md-table-cell md-label="Message" >{{ item.deviceId.serialNumber }} - {{ item.deviceId.deviceName }}</md-table-cell>
                                <md-table-cell md-label="Is Delivered">{{ item.isDelivered }}</md-table-cell>
                                <md-table-cell md-label="Is Open">{{ item.isOpen }}</md-table-cell>
                                <md-table-cell md-label="Open At">
                                    <span v-if="item.openDate">{{ HumanReadableDateFormat(item.openDate) }}</span>
                                    <span v-else>-</span>
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                        <h4 v-if="tableData.length == 0">No data found.</h4>
                    </div>
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
import NotificationService from "../../../services/SuperAdmin/NotificationService";

export default {
  components: {
  },
  data() {
    return {
      notificationId: this.$route.query.id,
      isDisabled: false,
      tableData: [],
      notificationDetail: null
    };
  },
  methods: {
      getNotificationDetail() {
        this.isDisabled = true;
        NotificationService.getNotificationDetail({ id: this.notificationId })
          .then((response) => {
            this.isDisabled = false;
            this.notificationDetail = response.data.data;
            this.tableData = response.data.data.notificationDetail;
          }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
      },
  },
  beforeMount() {
    this.getNotificationDetail();
  },
};
</script>